export default "__VITE_ASSET__BmMRpaop__"